/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NatureRdvService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Natures de rendez-vous
     * La liste des natures de rendez-vous de l'entreprise (visite, metre, pose...).
     * @returns string
     * @throws ApiError
     */
    public naturesRdvIndex(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/natures-rdv',
            errors: {
                400: `Header Company-Key absent.`,
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                404: `Aucune entreprise ne correspond a la Company-Key fournie.`,
            },
        });
    }
}
